export default function () {
  return {
    table: {
    }
  }
}
